import * as JWT from './axios-jwt';
import refresher from './refresher';

const applyAuthTokenInterceptor = (instance) =>
  JWT.applyAuthTokenInterceptor(instance, {
    requestRefresh: refresher,
  });

export { applyAuthTokenInterceptor };
